import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { useUXChrome } from "../contexts/UXChromeContext";

const isMac = typeof navigator !== "undefined" && /Mac|iPod|iPhone|iPad/.test(navigator.platform);
const MOD = isMac ? "⌘" : "Ctrl";

const SHORTCUTS = [
    { keys: [MOD, "K"], label: "Open command palette / search" },
    { keys: [MOD, "N"], label: "New record on the current list page" },
    { keys: ["/"], label: "Focus the current page&apos;s filter / search input" },
    { keys: ["?"], label: "Open this shortcut cheatsheet" },
    { keys: ["G", "H"], label: "Go to Home" },
    { keys: ["G", "F"], label: "Go to Master Finance" },
    { keys: ["G", "A"], label: "Go to AP Camp workspace" },
    { keys: ["G", "I"], label: "Go to IC Camp workspace" },
    { keys: ["G", "C"], label: "Go to Construction workspace" },
    { keys: ["Esc"], label: "Close the open palette / panel" },
];

function Kbd({ children }) {
    return (
        <kbd className="mono inline-flex items-center justify-center px-1.5 min-w-[1.5rem] h-6 text-[11px] rounded border bg-gray-50 asl-navy-text"
            style={{ borderColor: "var(--asl-border)" }}>
            {children}
        </kbd>
    );
}

export default function ShortcutsModal() {
    const { shortcutsOpen, setShortcutsOpen } = useUXChrome();
    return (
        <Dialog open={shortcutsOpen} onOpenChange={setShortcutsOpen}>
            <DialogContent className="max-w-md" data-testid="shortcuts-modal">
                <DialogHeader>
                    <DialogTitle>Keyboard shortcuts</DialogTitle>
                </DialogHeader>
                <ul className="space-y-2.5 pt-1">
                    {SHORTCUTS.map((s, i) => (
                        <li key={i} className="flex items-center justify-between text-sm" data-testid={`shortcut-row-${i}`}>
                            <span className="text-[color:var(--asl-muted)]" dangerouslySetInnerHTML={{ __html: s.label }} />
                            <span className="flex items-center gap-1">
                                {s.keys.map((k, j) => (
                                    <React.Fragment key={j}>
                                        <Kbd>{k}</Kbd>
                                        {j < s.keys.length - 1 && <span className="text-[10px] text-[color:var(--asl-muted)]">then</span>}
                                    </React.Fragment>
                                ))}
                            </span>
                        </li>
                    ))}
                </ul>
            </DialogContent>
        </Dialog>
    );
}
